import { Component } from "react";

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleScroll(event) {
    console.log('scroll on overlay')
    event.preventDefault()
  }

  render() {
    let buttonClasses = `absolute z-20 bg-white border-2 -top-3 -right-3 rounded-full flex items-center justify-center p-2 ${
      this.props.border
        ? `border-${this.props.border} text-${this.props.border}`
        : `border-khaki-default text-khaki-default`
    }`;
    return (
      <div
        className="fixed z-20 bg-gray-darkest bg-opacity-50 inset-0 h-screen flex items-center justify-center"
        onClick={(event) => this.props.onClick(event)} onScroll={(event) => this.handleScroll}
      >
        <div
          className="relative w-11/12 lg:w-8/12 z-30 maxmd:h-full max-h-4/5 overflow:auto overscroll-none"
          onClick={(event) => event.stopPropagation()}
        >
          <button
            className={buttonClasses}
            onClick={(event) => this.props.onClick(event)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16.974"
              height="16.974"
              viewBox="0 0 16.974 16.974"
              className="stroke-current"
            >
              <g
                id="Groupe_256"
                data-name="Groupe 256"
                transform="translate(-1053.007 -1252.007)"
              >
                <line
                  id="Ligne_38"
                  data-name="Ligne 38"
                  x2="12.731"
                  y2="12.731"
                  transform="translate(1055.128 1254.128)"
                  fill="none"
                  strokeLinecap="round"
                  strokeWidth="3"
                />
                <line
                  id="Ligne_39"
                  data-name="Ligne 39"
                  x2="12.731"
                  y2="12.731"
                  transform="translate(1067.859 1254.128) rotate(90)"
                  fill="none"
                  strokeLinecap="round"
                  strokeWidth="3"
                />
              </g>
            </svg>
          </button>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Modal;
